import {Card, CardContent, Typography} from "@mui/material";
import React from "react";

const ScoreCard = ({title, content}) => {
    return (
        <Card className="custom-card">
            <CardContent>
                <Typography variant="h5" className="gray-text" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="h6" className="gray-text" gutterBottom>
                    {content}
                </Typography>
            </CardContent>
        </Card>
    )
}

export default ScoreCard;